import React from 'react';
import { Box, Inscription, RawButton } from '@common-fe/common-fe';

interface Props {
  count: number;
  onAddClick: () => void;
}

export const EmployerReactivationBankListHeader: React.FC<Props> = ({
  count,
  onAddClick,
}) => {
  return (
    <Box
      data-testid="EmployerReactivationBankListHeader"
      direction="row"
      margin={{ bottom: 'spacing8' }}
      justify="between"
      align="center"
    >
      <Inscription
        data-testid="EmployerReactivationBankListHeader_count"
        weight="bold"
        color="textBody"
        lineHeight="20px"
      >
        Bank accounts: {count}
      </Inscription>

      <RawButton
        data-testid="EmployerReactivationBankListHeader_add-button"
        onClick={onAddClick}
        style={{ marginBottom: '2px' }}
      >
        <Inscription color="textAccent" weight="normal">
          Add Bank Account
        </Inscription>
      </RawButton>
    </Box>
  );
};
